export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ea36fb100c440172e1be4ba38ce3eec000a38d8b&name=pushAdClickData!'